export const SESSION_MAP_PATH = '/session/{userId}' as const;
export type SessionMapPath = typeof SESSION_MAP_PATH;

export const toSessionMapPath = (userId: string) => {
  return SESSION_MAP_PATH.replace('{userId}', userId);
};

export const SESSION_PATH = `${SESSION_MAP_PATH}/{sessionId}` as const;
export type SessionPath = typeof SESSION_PATH;

export const toSessionPath = (userId: string, sessionId: string) => {
  return SESSION_PATH.replace('{userId}', userId).replace(
    '{sessionId}',
    sessionId,
  );
};
